module.exports = __webpack_public_path__ + "img/pdf-logo.d63049de.png";